import { includes, pathOr, propEq, find, compose, lensPath, set } from "ramda";
import { isNotEmpty } from "src/utilities/hasValue";
import { formattedActiveAnswer } from "./navigationAction";
import { getLoanAppByNamespace } from 'src/hooks/useLoanApp';
import { useApplicantManagement } from 'src/hooks/useAuthenticatedContext';
import { LoanAppsLoader } from "src/features/LoansHome/Loans/LoanAppsLoader";
import { notHasWorkflowLoanActive } from "src/features/utilities";


//Converting Json string to Json data
export const mkAnswer = (data: any) => {
  const apiResourcePath = pathOr('', ['metadata', 'api_resource_path'], data);
  // if answerType is Object we are converting string to json
  const value = formattedActiveAnswer(data);
  const updValue = isNotEmpty(apiResourcePath) && includes(value, ['-', 'none']) ? {} : value
  return updValue;
}

/**
* getIntentByKeyField - gives out answer from list of intents for the given key field
* @param intents can have a list of intents
* @param key can have a key field as string
*/
export const getIntentByKeyField = (intents: any, key: string) => {
  const intent = find(propEq('key_field', key), intents)
  const answer = mkAnswer(intent)
  return {
    answer,
    intent
  }
};


export const clearPwdlessSession = () => {
  sessionStorage.clear();
}

export const getAllLoanApp = () => {
  /** Here fetch the all the Loan app List using the NameSpace for the Rule_Context */
  const { applicantAccountId } = useApplicantManagement();
  if (!notHasWorkflowLoanActive()) {
    const { data } = getLoanAppByNamespace(applicantAccountId);
    const loanAppsLoader = new LoanAppsLoader('', applicantAccountId, data)
    return loanAppsLoader.getLoanApps();
  }
  return []
}

export const mutateCurrentIntent = (intent: any, path: string, key: string, value: string) => {
  const updIntent = compose(
    set(lensPath([path, key]), value),
  )(intent);
  return updIntent;
}
